import {Component, computed, inject, OnDestroy, OnInit, signal, viewChildren, WritableSignal} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {KycService} from '../../../services/kyc.service'
import {CountrySelectComponent} from '../../../form/00-pure/28a-country/country-select.component'

@Component({
  selector: 'spb-citizenship',
  imports: [
    MatButton,
    MatIcon,
    CountrySelectComponent
  ],
  templateUrl: './citizenship.component.html',
  styleUrl: './citizenship.component.scss'
})
export class CitizenshipComponent implements OnInit, OnDestroy {

  public countries = signal<WritableSignal<string>[]>([])

  public children = viewChildren(CountrySelectComponent)

  public valid = computed(() =>
    this.children().every(c => c.valid()))


  public countryList = computed(() =>
    this.countries().map((country) => country()))


  public kycService = inject(KycService)

  public ngOnInit(): void {
    this.countries.set(this.kycService.kycModel.nationalities.map(s => signal(s)))
  }

  public ngOnDestroy(): void {
    // Only set it if valid, in case someone press "back".
    if (this.valid()) {
      this.kycService.kycModel.nationalities =
        this.countries().map(c => c())
    }
  }

  public addNationality(): void {
    this.countries.update(cs => {
      cs.push(signal(''))
      return [...cs]
    })
  }

  public removeNationality() {
    this.countries.update(cs => {
      cs.pop()
      return [...cs]
    })
  }
}
